// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2FtYP","footer":"ModalInfo_footer__1PrEh"};